import React, { useState, useEffect } from 'react';
import { SidebarPortal, BlockDataForm } from '@plone/volto/components';
import { Button, Form, Input } from 'semantic-ui-react';
import LocalizzazioneSchema from './schema';
import RichTextEditor from './RichTextEditor';

const Edit = (props) => {
  const { data, onChangeBlock, block, selected } = props;
  const [street, setStreet] = useState(data.street || '');
  const [zipCode, setZipCode] = useState(data.zipCode || '');
  const [city, setCity] = useState(data.city || '');
  const [coordinates, setCoordinates] = useState(data.coordinates || [44.809984, 10.323001]);
  const [MapComponent, setMapComponent] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (typeof window !== 'undefined') {
      import('./MapComponent')
        .then((module) => {
          setMapComponent(() => module.default);
          setIsLoading(false);
        })
        .catch((error) => {
          console.error('Errore nel caricamento di MapComponent:', error);
          setIsLoading(false);
        });
    }
  }, []);

  const handleGeocode = () => {
    const fullAddress = `${street}, ${zipCode} ${city}`;
    fetch(`https://nominatim.openstreetmap.org/search?format=json&q=${encodeURIComponent(fullAddress)}`)
      .then((response) => response.json())
      .then((responseData) => {
        if (responseData.length > 0) {
          const { lat, lon } = responseData[0];
          const newCoordinates = [parseFloat(lat), parseFloat(lon)];
          setCoordinates(newCoordinates);
          onChangeBlock(block, {
            ...data,
            coordinates: newCoordinates,
            street,
            zipCode,
            city,
          });
        } else {
          console.error('Nessuna coordinata trovata per questo indirizzo');
        }
      })
      .catch((error) => console.error('Errore nel geocoding:', error));
  };

  const onChangeField = (id, value) => {
    if (id === 'street') setStreet(value);
    if (id === 'zipCode') setZipCode(value);
    if (id === 'city') setCity(value);
    // console.log('Field changed:', id, value); // Log temporaneo
    onChangeBlock(block, {
      ...data,
      [id]: value,
    });
  };

  const handleCoordinatesChange = (newCoordinates) => {
    setCoordinates(newCoordinates);
    onChangeBlock(block, {
      ...data,
      coordinates: newCoordinates,
    });
  };

  const schemaWithCustomWidget = {
    ...LocalizzazioneSchema,
    properties: {
      ...LocalizzazioneSchema.properties,
      description: {
        ...LocalizzazioneSchema.properties.description,
        widget: 'custom_richtext',
        component: RichTextEditor,
      },
    },
  };

  return (
    <div className="block-localizzazione">
      <div style={{ display: 'flex', flexDirection: data.mapPosition === 'left' ? 'row' : 'row-reverse' }}>
        <div style={{ flex: 1, height: '400px' }}>
          {isLoading || !MapComponent ? (
            <div>Caricamento mappa...</div>
          ) : (
            <MapComponent
              coordinates={coordinates}
              isEditMode={true}
              onCoordinatesChange={handleCoordinatesChange}
            />
          )}
        </div>

        <div style={{ flex: 1, padding: '10px' }}>
          <Form>
            <Form.Field>
              <Input
                label="Via"
                value={street}
                onChange={(e, { value }) => onChangeField('street', value)}
                required
              />
            </Form.Field>
            <Form.Field>
              <Input
                label="CAP"
                value={zipCode}
                onChange={(e, { value }) => onChangeField('zipCode', value)}                
              />
            </Form.Field>
            <Form.Field>
              <Input
                label="Città"
                value={city}
                onChange={(e, { value }) => onChangeField('city', value)}
                required
              />
            </Form.Field>
            <Button primary onClick={handleGeocode}>
              Trova Coordinate
            </Button>
          </Form>
        </div>
      </div>
      <SidebarPortal selected={selected}>
        <BlockDataForm
          schema={schemaWithCustomWidget}
          title={LocalizzazioneSchema.title}
          onChangeField={onChangeField}
          formData={data}
          block={block}
        />
      </SidebarPortal>
    </div>
  );
};

export default Edit;